import { colors } from '../foundation';

type Props = {
  color?: typeof colors.primary.grey | typeof colors.primary.white | (typeof colors.red)[100];
  size?: 32 | 18 | 16;
};
const Check = ({ color, size = 16 }: Props) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon / Basic / Check">
        <path
          id="Icon/Back (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.82424 11.3983L6.39998 10.974L5.97571 11.3983C6.21003 11.6326 6.58993 11.6326 6.82424 11.3983ZM6.39998 10.1255L3.62424 7.34977C3.38993 7.11546 3.01003 7.11546 2.77571 7.34977C2.5414 7.58409 2.5414 7.96399 2.77571 8.1983L5.97571 11.3983L6.39998 10.974C6.82424 11.3983 6.8242 11.3983 6.82424 11.3983L12.9983 5.22429C13.2326 4.98997 13.2326 4.61007 12.9983 4.37576C12.7639 4.14144 12.384 4.14144 12.1497 4.37576L6.39998 10.1255Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
export default Check;
